import '../../shared/error-boundary.ts';
/**
 * Tool page entry — data-json-minify
 */

import { jsonMinify } from '@bytario/core/data/json-minify';
import { createProgress, yieldToPaint } from '../../shared/progress.ts';

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  })[c]!);
}

function formatBytes(n: number): string {
  if (n < 1024) return n + ' B';
  if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB';
  return (n / (1024 * 1024)).toFixed(2) + ' MB';
}

const button = document.querySelector('#run') as HTMLButtonElement;
button.addEventListener('click', async () => {
  const input = (document.querySelector('#text') as HTMLTextAreaElement).value;
  if (!input.trim()) return;
  const p = createProgress('#result', ['Minifying', 'Complete']);
  try {
    p.activate(0);
    await yieldToPaint();
    const minified = await jsonMinify(new TextEncoder().encode(input));
    const output = typeof minified === 'string' ? minified : new TextDecoder().decode(minified);
    const inputBytes = new TextEncoder().encode(input).length;
    const outputBytes = new TextEncoder().encode(output).length;
    const saved = inputBytes - outputBytes;
    const pct = inputBytes > 0 ? ((saved / inputBytes) * 100).toFixed(1) : '0';
    p.complete(0);

    p.activate(1);
    p.complete(1);
    p.finish(
      '<div class="compression-stats">' +
        '<span>Before: <strong>' + formatBytes(inputBytes) + '</strong></span>' +
        '<span>After: <strong>' + formatBytes(outputBytes) + '</strong></span>' +
        '<span>Saved: <strong>' + formatBytes(saved) + ' (' + pct + '%)</strong></span>' +
      '</div>' +
      '<pre class="wrap">' + escapeHtml(output) + '</pre>'
    );
  } catch (e) {
    p.error(String(e));
  }
});
